import { render, staticRenderFns } from "./LoginHistory.vue?vue&type=template&id=72bde89d&"
import script from "./LoginHistory.vue?vue&type=script&lang=js&"
export * from "./LoginHistory.vue?vue&type=script&lang=js&"
import style0 from "./LoginHistory.vue?vue&type=style&index=0&id=72bde89d&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports